<template>
  <div class="m-flex-clounm m-four-detail">
    <div class="m-img-succ"><img src="../../assets/images/wanc@2x.png" style="width: 84px;"></div>
    <h3 class="m-form-title">预定完成</h3>
    <p class="finish-text">微信扫描下方二维码,随时查看服务进度</p>
    <div class="m-flex-row m-img-tip">
      <div class="m-ewm"><img  src="../../assets/images/m-erm.jpg"/></div>
      <div class="m-phone-show" style="margin-left: -10px"><img src="../../assets/images/m-show-phone-2x.png" style="width: 207px;"/></div>
    </div>
  </div>
</template>
<script>
  export default{
      name:"pay-finish"
  }
</script>
<style scoped>
.finish-text {
  margin-top: 11px;
  font-size: 13px;
  font-weight: 400;
  color: #9394A3;
  line-height: 18px;
  text-align: center;
}
.m-four-detail {
  margin-top: 113px;
}
</style>



// WEBPACK FOOTER //
// pay-finish.vue?cf5eb908